export const WIDTH_OWNERS = 80;
export const WIDTH_TENANTS = 140;
export const WIDTH_CONTRACT_DATE = 100;
